"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COLOR_CATEGORY_KEY = 'base';
exports.COLOR_COMPONENT_KEY = 'color';